import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import { breadcrumbsReducerKey } from '@Containers/Breadcrumbs/BreadcrumbsConstants';
import {
  retrieveBreadcrumbs as retrieveBreadcrumbsAction,
  goToResultPage as goToResultPageAction,
  backToQueryHandler as backToQueryHandlerAction,
} from '@Containers/Breadcrumbs/BreadcrumbsActions';
import { breadcrumbsIdsOrdered, breadcrumbsItems } from '@Containers/Breadcrumbs/BreadcrumbsSelectors';
import breadcrumbsReducer from '@Containers/Breadcrumbs/BreadcrumbsReducer';
import Breadcrumbs from './Breadcrumbs';

function mapStateToProps(state) {
  return {
    databaseId: databaseIdSelector(state),
    breadcrumbsIds: breadcrumbsIdsOrdered(state),
    breadcrumbsItems: breadcrumbsItems(state),
  };
}

const mapDispatchToProps = {
  retrieveBreadcrumbs: retrieveBreadcrumbsAction,
  goToResultPage: goToResultPageAction,
  backToQueryHandler: backToQueryHandlerAction,
};

export function BreadcrumbsContainer(props) {
  const { retrieveBreadcrumbs, databaseId, resultName } = props;

  useEffect(() => {
    if (databaseId && resultName) {
      retrieveBreadcrumbs(databaseId);
    }
  }, [retrieveBreadcrumbs, databaseId, resultName]);

  return <Breadcrumbs {...props} />;
}

BreadcrumbsContainer.propTypes = {
  retrieveBreadcrumbs: PropTypes.func.isRequired,
  databaseId: PropTypes.string.isRequired,
  resultName: PropTypes.string,
};

const EnhancedBreadcrumbsContainer = compose(
  withCombinedRouteParams,
  withReducer(breadcrumbsReducerKey, breadcrumbsReducer, true),
  connect(mapStateToProps, mapDispatchToProps)
)(BreadcrumbsContainer);

export default EnhancedBreadcrumbsContainer;
